const UploadState = {
  IDLE: 'idle',
  UPLOADING: 'uploading',
  PREVIEW: 'preview',
  SUCCESS: 'success',
  ERROR: 'error',
};

export default UploadState;

export const { IDLE, UPLOADING, PREVIEW, SUCCESS, ERROR } = UploadState;
